import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

// import { createUserTransactions } from 'src/axious/user-transactions'
import { TransactionContainer } from 'src/components/ui'

// import { handleAxiosError } from 'src/utils/errorHandling'
// import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

interface Props {
  className?: string
}

const WithdrawalTonPage: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const redirectToWalletPage = (starsAmount: string) => {
    navigate(`/withdrawal/ton/wallet-address?stars=${starsAmount}`)
  }

  return (
    <div className={className}>
      <TransactionContainer
        typeOfHeader='back'
        title={t('withdrawal_page.ton.title')}
        subtitle={t('withdrawal_page.ton.subtitle')}
        buttonText={t('withdrawal_page.ton.button_text')}
        onTransferStars={redirectToWalletPage}
        minValueForTransaction={500}
        typeOfTransaction='withdraw'
      />
    </div>
  )
}

export default WithdrawalTonPage
